import { render, staticRenderFns } from "./Calificacion.vue?vue&type=template&id=7f2ff9d7&"
import script from "./Calificacion.vue?vue&type=script&lang=js&"
export * from "./Calificacion.vue?vue&type=script&lang=js&"
import style0 from "./Calificacion.vue?vue&type=style&index=0&id=7f2ff9d7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports